/**
 * Finch overlay for product card color swatches.
 * Fixes variant link href on product cards without modifying theme core product-card.js.
 */
(function () {
	const BOUND_ATTR = "data-finch-swatch-href-bound";

	function getVariantLink(input, productHandle) {
		if (input.dataset.productUrl) {
			return input.dataset.productUrl;
		}

		if (input.dataset.variantId) {
			return `${window.Shopify.routes.root}products/${productHandle}?variant=${input.dataset.variantId}`;
		}

		return null;
	}

	function updateColorSwatchLinks(wrapper, variantLink) {
		if (!variantLink) {
			return;
		}

		wrapper.querySelectorAll(".js-color-swatches-link").forEach((link) => {
			link.setAttribute("href", variantLink);
		});
	}

	function bindColorSwatchWrapper(wrapper) {
		const productHandle = wrapper.dataset.product;
		if (!productHandle) {
			return;
		}

		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			if (
				input.closest("variant-radios") ||
				input.closest("variant-selects") ||
				input.closest(".product-section")
			) {
				return;
			}

			if (input.hasAttribute(BOUND_ATTR)) {
				return;
			}

			input.setAttribute(BOUND_ATTR, "true");

			input.addEventListener("change", () => {
				if (!input.checked) {
					return;
				}

				updateColorSwatchLinks(
					wrapper,
					getVariantLink(input, productHandle),
				);

				if (typeof jQuery === "undefined") {
					return;
				}

				jQuery.getJSON(
					`${window.Shopify.routes.root}products/${productHandle}.js`,
					function (product) {
						const variant = product.variants.find(
							(item) =>
								item.featured_media != null &&
								item.options.includes(input.value),
						);

						if (!variant) {
							return;
						}

						updateColorSwatchLinks(
							wrapper,
							variant.url ||
								`${window.Shopify.routes.root}products/${productHandle}?variant=${variant.id}`,
						);
					},
				);
			});
		});
	}

	function initFinchColorSwatchLinks() {
		document
			.querySelectorAll(".js-color-swatches-wrapper")
			.forEach(bindColorSwatchWrapper);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initFinchColorSwatchLinks);
	} else {
		initFinchColorSwatchLinks();
	}

	document.addEventListener("shopify:section:load", initFinchColorSwatchLinks);
})();
